module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"redirect_message":"Moving in %{second} seconds."}}')
  delete Component.options._Ctor
}
